// Client-side persistence for message actions (reactions, stars, pins, deletes).
// These mirror WhatsApp UX without requiring backend schema changes.
// Keyed by message id → { reactions: {emoji: count}, myReaction: string|null, starred, pinned, deleted }.

const KEY = 'inbox_msg_actions_v1';

export const readAll = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
};

const writeAll = (data) => {
  try { localStorage.setItem(KEY, JSON.stringify(data)); } catch { /* quota */ }
};

export const getActions = (msgId) => {
  if (!msgId) return {};
  const all = readAll();
  return all[msgId] || {};
};

export const setMyReaction = (msgId, emoji) => {
  if (!msgId) return {};
  const all = readAll();
  const cur = all[msgId] || { reactions: {}, myReaction: null };
  const reactions = { ...(cur.reactions || {}) };
  // Remove previous reaction count by me
  if (cur.myReaction) {
    reactions[cur.myReaction] = Math.max(0, (reactions[cur.myReaction] || 1) - 1);
    if (!reactions[cur.myReaction]) delete reactions[cur.myReaction];
  }
  if (emoji) reactions[emoji] = (reactions[emoji] || 0) + 1;
  const next = { ...cur, reactions, myReaction: emoji || null };
  all[msgId] = next;
  writeAll(all);
  return next;
};

export const toggleStar = (msgId) => {
  if (!msgId) return {};
  const all = readAll();
  const cur = all[msgId] || {};
  const next = { ...cur, starred: !cur.starred };
  all[msgId] = next;
  writeAll(all);
  return next;
};

export const togglePin = (msgId) => {
  if (!msgId) return {};
  const all = readAll();
  const cur = all[msgId] || {};
  const next = { ...cur, pinned: !cur.pinned };
  all[msgId] = next;
  writeAll(all);
  return next;
};

export const markDeleted = (msgId) => {
  if (!msgId) return {};
  const all = readAll();
  const cur = all[msgId] || {};
  const next = { ...cur, deleted: true };
  all[msgId] = next;
  writeAll(all);
  return next;
};

export const FWD_MARKER = '[FWD]::';

export const isForwarded = (text) => typeof text === 'string' && text.startsWith(FWD_MARKER);

export const stripForwardMarker = (text) => (isForwarded(text) ? text.slice(FWD_MARKER.length) : text);

export const withForwardMarker = (text) => FWD_MARKER + (text || '');

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text || '');
    return true;
  } catch {
    return false;
  }
};

// Merge persistent UI state onto a list of messages for rendering.
export const hydrateActions = (messages) => {
  const all = readAll();
  return messages.map(m => {
    const a = all[m.id];
    if (!a) return m;
    return { ...m, __ui: a };
  });
};
